<template>
  <mk-dialog
    :visible.sync="show"
    width="456px"
    height="158px"
    class="list-table-action-dialog"
    @close="onClose"
  >
    <div class="list-table-action-dialog__header">
      <span class="list-table-action-dialog__icon">
        <mk-iconfont
          v-if="type === 'error'"
          icon-class="guanbihuojingshihuocuowu"
        />
        <ds-iconfont
          v-if="type === 'warning'"
          icon-class="icon-mk-jingshi"
        >
        </ds-iconfont>
      </span>
      <span class="list-table-action-dialog__title">{{ title }}</span>
      <i
        class="el-icon-close"
        @click="handleOnCloseClick"
      >
      </i>
    </div>
    <div class="list-table-action-dialog__text">
      {{ text }}
    </div>
    <div class="list-table-action-dialog__button">
      <slot name="enter-button">
        <mk-button-biz
          width="72px"
          height="36px"
          class="list-table-action-dialog__enter"
          @click="handleOnEnterClick"
        >
          确定
        </mk-button-biz>
      </slot>
    </div>
  </mk-dialog>
</template>

<script>
export default {
  name: 'ListTableActionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '删除失败'
    },
    text: {
      type: String,
      default: '该考试已关联学习任务，不能被删除，请先从任务中移除。'
    },
    close: {
      type: Boolean,
      default: true
    },
    // icon 类型 success,warning,info,error
    type: {
      type: String,
      default: 'warning'
    }
  },
  data () {
    return {
      show: this.visible
    }
  },
  methods: {
    onClose () {
      this.$emit('on-close')
    },
    handleOnEnterClick () {
      this.$emit('on-enter-click')
    },
    handleOnCloseClick () {
      this.$emit('on-close')
    },
    handleOnCancelClick () {
      this.$emit('on-close')
    }
  }
}
</script>

<style lang="scss" scoped>
.list-table-action-dialog {
  /deep/ .el-dialog__header {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    margin: 17px 20px 20px;
  }

  .list-table-action-dialog__header {
    height: 20px;
    line-height: 20px;
    display: flex;
  }

  .list-table-action-dialog__title {
    font-weight: 500;
    margin-left: 8px;
    margin-right: 20px;
    width: 344px;
    font-size: 16px;
    color: #262626;
  }

  .el-icon-close {
    font-size: 20px;
    color: #bfbfbf;
  }

  .icon-mk-guanbihuojingshihuocuowu {
    font-size: 20px;
    color: #f5222d;
  }

  .icon-mk-jingshi {
    color: #faad14;
    font-size: 24px;
  }

  .list-table-action-dialog__text {
    margin-left: 28px;
    margin-top: 12px;
    height: 48px;
    font-size: 14px;
    color: #595959;
  }

  .list-table-action-dialog__button {
    text-align: right;
  }

  .list-table-action-dialog__enter {
    border: 1px solid #009cff;
    color: #fff;
    background: #009cff;
  }
}
</style>
